"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInternalMultisigAddress = exports.SENDMULTISIG_SIG_HASH = exports.txInteractsWithContract = exports.getSigHash = void 0;
const ethers_1 = require("ethers");
const multiSig_1 = __importDefault(require("./abi/multiSig"));
const getSigHash = (inputData) => {
    if (!inputData)
        return;
    const length = inputData.startsWith('0x') ? 10 : 8;
    return inputData.slice(0, length);
};
exports.getSigHash = getSigHash;
const txInteractsWithContract = (tx, contract) => {
    var _a, _b;
    const receiveAddress = (_b = (_a = tx.vout[0].addresses) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : '';
    return receiveAddress === contract;
};
exports.txInteractsWithContract = txInteractsWithContract;
exports.SENDMULTISIG_SIG_HASH = (() => {
    const abiInterface = new ethers_1.ethers.utils.Interface(multiSig_1.default);
    return abiInterface.getSighash('sendMultiSig');
})();
// detect address associated with sendMultiSig internal transaction
const getInternalMultisigAddress = (inputData) => {
    const abiInterface = new ethers_1.ethers.utils.Interface(multiSig_1.default);
    if ((0, exports.getSigHash)(inputData) !== exports.SENDMULTISIG_SIG_HASH)
        return;
    const result = abiInterface.decodeFunctionData(exports.SENDMULTISIG_SIG_HASH, inputData);
    return result.toAddress;
};
exports.getInternalMultisigAddress = getInternalMultisigAddress;
